var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pa-2" },
            [
              _c(
                "h1",
                {
                  staticClass:
                    "text-h4 font-weight-bold text-left primary--text pb-4 float-left",
                },
                [_vm._v("Target Object Attributes")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "mx-4 float-left",
                  attrs: {
                    fab: "",
                    dark: "",
                    "x-small": "",
                    color: "primary",
                    label: "Refresh",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.getItemsFiltered()
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        "aria-hidden": "false",
                        "aria-label": "Refresh",
                        dark: "",
                      },
                    },
                    [_vm._v("mdi-refresh")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pa-2" },
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.items,
                  "item-key": "id",
                  options: _vm.options,
                  "server-items-length": _vm.totalItems,
                  loading: _vm.loading,
                  "loading-text": "Loading... Please wait",
                  "footer-props": {
                    showFirstLastPage: true,
                    itemsPerPageOptions: [20, 50, 100],
                  },
                  "fixed-header": "",
                  dense: "",
                },
                on: {
                  "update:options": function ($event) {
                    _vm.options = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "top",
                    fn: function () {
                      return [
                        _c(
                          "v-col",
                          { attrs: { md: "12", xs: "12" } },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { md: "6", xs: "6" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: "Search by Target Object",
                                        items:
                                          _vm.filteredLookupData.targetObjects,
                                        "item-text": "text",
                                        "item-value": "id",
                                        placeholder: "Search by Target Object",
                                        outlined: "",
                                        dense: "",
                                        clearable: "",
                                        multiple: "",
                                      },
                                      on: { change: _vm.getItemsByOptions },
                                      model: {
                                        value:
                                          _vm.filterOptions.targetObjectIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterOptions,
                                            "targetObjectIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "filterOptions.targetObjectIds",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { md: "6", xs: "6" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label:
                                          "Search by Target Object Attribute",
                                        items:
                                          _vm.filteredLookupData
                                            .targetObjectAttributes,
                                        "item-text": "text",
                                        "item-value": "id",
                                        placeholder:
                                          "Search by Target Object Attribute",
                                        outlined: "",
                                        dense: "",
                                        clearable: "",
                                        multiple: "",
                                      },
                                      on: { change: _vm.getItemsByOptions },
                                      model: {
                                        value:
                                          _vm.filterOptions
                                            .targetObjectAttributeIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterOptions,
                                            "targetObjectAttributeIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "filterOptions.targetObjectAttributeIds",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { md: "6", xs: "6" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: "Search by Data Owner",
                                        items:
                                          _vm.filteredLookupData.dataOwners,
                                        "item-text": "text",
                                        "item-value": "id",
                                        placeholder: "Search by Data Owner",
                                        outlined: "",
                                        dense: "",
                                        clearable: "",
                                        multiple: "",
                                      },
                                      on: { change: _vm.getItemsByOptions },
                                      model: {
                                        value: _vm.filterOptions.dataOwnerIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterOptions,
                                            "dataOwnerIds",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "filterOptions.dataOwnerIds",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "item.targetObjectAttributeName",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "v-chip--clickable",
                            on: {
                              click: function ($event) {
                                return _vm.editItem(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(item.targetObjectAttributeName) +
                                " [" +
                                _vm._s(item.id) +
                                "]"
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.loadDateText",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "v-chip--clickable",
                            on: {
                              click: function ($event) {
                                return _vm.editItem(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.loadDateText))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.targetObjectName",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "v-chip--clickable",
                            on: {
                              click: function ($event) {
                                return _vm.editItem(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(item.targetObjectName) +
                                " [" +
                                _vm._s(item.targetObjectId) +
                                "] " +
                                _vm._s(item.targetObjectPlatformName) +
                                " [" +
                                _vm._s(item.targetObjectPlatformId) +
                                "]"
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.dataOwnerName",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "v-chip--clickable",
                            on: {
                              click: function ($event) {
                                return _vm.editItem(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.dataOwnerName))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { left: "", "max-width": "400" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                "aria-label": "Edit",
                                                "aria-hidden": "false",
                                                color: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editItem(item)
                                                },
                                              },
                                            },
                                            "v-icon",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_vm._v("mdi-pencil")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Click to Edit/View this item. You must be the data owner or data set owner to Save any changes"
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "no-data",
                    fn: function () {
                      return [
                        _c(
                          "v-alert",
                          {
                            staticClass: "mt-4",
                            attrs: {
                              type: "warning",
                              dense: "",
                              border: "left",
                            },
                          },
                          [_vm._v(" Sorry, no data to display ")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "no-results",
                    fn: function () {
                      return [
                        _c(
                          "v-alert",
                          {
                            staticClass: "mt-4",
                            attrs: {
                              type: "warning",
                              dense: "",
                              border: "left",
                            },
                          },
                          [_vm._v(" Sorry, no results found ")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "v-overlay",
                {
                  staticClass: "align-center justify-center",
                  attrs: { value: _vm.overlay },
                },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: "64" },
                  }),
                ],
                1
              ),
              _c(
                "v-dialog",
                {
                  attrs: {
                    fullscreen: "",
                    scrollable: "",
                    transition: "dialog-bottom-transition",
                  },
                  model: {
                    value: _vm.editDialog,
                    callback: function ($$v) {
                      _vm.editDialog = $$v
                    },
                    expression: "editDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: "mb-5 flex-grow-0",
                          attrs: { dark: "", color: "primary" },
                        },
                        [
                          _c("v-toolbar-title", [
                            _vm._v(
                              "Edit - " +
                                _vm._s(
                                  _vm.editedItem.targetObjectAttributeName
                                ) +
                                " [" +
                                _vm._s(_vm.editedItem.targetObjectAttributeId) +
                                "]"
                            ),
                          ]),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: { click: _vm.closeEditDialog },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    "aria-label": "Close",
                                    "aria-hidden": "false",
                                  },
                                },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        { staticClass: "py-3" },
                        [
                          _c(
                            "v-form",
                            {
                              ref: "targetObjectAttributeEditForm",
                              model: {
                                value: _vm.editItemIsValid,
                                callback: function ($$v) {
                                  _vm.editItemIsValid = $$v
                                },
                                expression: "editItemIsValid",
                              },
                            },
                            [
                              _c(
                                "v-container",
                                { attrs: { fluid: "" } },
                                [
                                  !_vm.editItemIsValid
                                    ? _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "v-alert",
                                                {
                                                  attrs: {
                                                    color: "pink darken-1",
                                                    outlined: "",
                                                    dense: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "All data provided must be valid. Any fields marked with "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "red--text",
                                                    },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(" are required."),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-autocomplete", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              items:
                                                _vm.lookupData.targetObjects,
                                              "item-text": "text",
                                              "item-value": "id",
                                              rules: [
                                                (v) =>
                                                  !!v ||
                                                  "Select a Target Object",
                                              ],
                                              placeholder:
                                                "Select a Target Object",
                                              required: "",
                                              outlined: "",
                                              dense: "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _vm._v(
                                                      " Target Object Name "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "red--text",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value:
                                                _vm.editedItem.targetObjectId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "targetObjectId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.targetObjectId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              maxlength: 120,
                                              rules: [
                                                (v) =>
                                                  !!v ||
                                                  "Target Object Attribute Name is required",
                                              ],
                                              required: "",
                                              outlined: "",
                                              counter: "",
                                              dense: "",
                                              clearable: "",
                                              hint: "MANDATORY FIELD - Attribute name - must match attribute name in source, UDL and data catalogue/DMR.",
                                              "persistent-hint": "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _vm._v(
                                                      " Target Object Attribute Name "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "red--text",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value:
                                                _vm.editedItem
                                                  .targetObjectAttributeName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "targetObjectAttributeName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.targetObjectAttributeName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              maxlength: 120,
                                              rules: [
                                                (v) =>
                                                  !!v ||
                                                  "Display Name is required",
                                              ],
                                              required: "",
                                              outlined: "",
                                              counter: "",
                                              dense: "",
                                              clearable: "",
                                              hint: "REQUIRED FOR FS REVIEW - Often the same as the TargetObjectAttribute but should be in a readable format (don't use camel case here). Check naming standards doc",
                                              "persistent-hint": "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _vm._v(" Display Name "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "red--text",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value: _vm.editedItem.displayName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "displayName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.displayName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "FS Review Rename",
                                              maxlength: 120,
                                              outlined: "",
                                              counter: "",
                                              dense: "",
                                              clearable: "",
                                              hint: "Only for use if you want to change the name of an already existing attribute in prod.",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem.fsreviewRename,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "fsreviewRename",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.fsreviewRename",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "Aggregation Method",
                                              maxlength: 25,
                                              outlined: "",
                                              counter: "",
                                              dense: "",
                                              clearable: "",
                                              hint: "Only for use if it is a measure",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem
                                                  .aggregationMethod,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "aggregationMethod",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.aggregationMethod",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-autocomplete", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              items: _vm.lookupData.dataTypes,
                                              "item-text": "text",
                                              "item-value": "id",
                                              rules: [
                                                (v) =>
                                                  !!v || "Select a Data Type",
                                              ],
                                              placeholder: "Select a Data Type",
                                              required: "",
                                              outlined: "",
                                              dense: "",
                                              hint: "REQUIRED FOR FS REVIEW - Datatype of attribute. Information should be obtained from the DMR for UDL ingestion. Use the dropdown options available",
                                              "persistent-hint": "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _vm._v(" Data Type "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "red--text",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value: _vm.editedItem.dataTypeId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "dataTypeId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.dataTypeId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-autocomplete", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              items: _vm.lookupData.dataOwners,
                                              "item-text": "text",
                                              "item-value": "id",
                                              rules: [
                                                (v) =>
                                                  !!v || "Select a Data Owner",
                                              ],
                                              placeholder:
                                                "Select a Data Owner",
                                              required: "",
                                              outlined: "",
                                              dense: "",
                                              hint: "Data Owner for individual TOA.",
                                              "persistent-hint": "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _vm._v(" Data Owner "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "red--text",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value: _vm.editedItem.dataOwnerId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "dataOwnerId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.dataOwnerId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "Description",
                                              maxlength: 1000,
                                              rules: [
                                                (v) =>
                                                  !!v ||
                                                  "Description is required",
                                              ],
                                              counter: "",
                                              outlined: "",
                                              "auto-grow": "",
                                              clearable: "",
                                              dense: "",
                                              required: "",
                                              hint: "REQUIRED FOR FS REVIEW - Business level description of the specific attribute. Put this into Readable English. This should reflect the TargetObjectName",
                                              "persistent-hint": "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _vm._v(" Description "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "red--text",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value: _vm.editedItem.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-autocomplete", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label:
                                                "Data Classification Detail",
                                              items:
                                                _vm.lookupData
                                                  .dataClassificationDetails,
                                              "item-text": "text",
                                              "item-value": "id",
                                              rules: [
                                                (v) =>
                                                  !!v ||
                                                  "Select Data Classification Detail",
                                              ],
                                              placeholder:
                                                "Select Data Classification Detail",
                                              required: "",
                                              outlined: "",
                                              dense: "",
                                              clearable: "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _vm._v(
                                                      " Data Classification Detail "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "red--text",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value:
                                                _vm.editedItem
                                                  .dataClassificationDetailId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "dataClassificationDetailId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.dataClassificationDetailId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              staticClass: "mb-4",
                                              attrs: {
                                                rules: [
                                                  (v) =>
                                                    v != null ||
                                                    "Select an answer",
                                                ],
                                                dense: "",
                                                hint: "MANDATORY FIELD - This refers to how the attribute relates to other data elsewhere in the model.",
                                                "persistent-hint": "",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        " Is Foreign Key? "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "red--text",
                                                        },
                                                        [_vm._v("*")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ]),
                                              model: {
                                                value:
                                                  _vm.editedItem.foreignKey,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "foreignKey",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.foreignKey",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Yes",
                                                  value: true,
                                                },
                                              }),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "No",
                                                  value: false,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              staticClass: "mb-4",
                                              attrs: {
                                                rules: [
                                                  (v) =>
                                                    v != null ||
                                                    "Select an answer",
                                                ],
                                                dense: "",
                                                hint: "MANDATORY FIELD - This refers to what defines a unique row. There should be at least one attribute with a Primary Key",
                                                "persistent-hint": "",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        " Is Primary Key? "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "red--text",
                                                        },
                                                        [_vm._v("*")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ]),
                                              model: {
                                                value:
                                                  _vm.editedItem.primaryKey,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "primaryKey",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.primaryKey",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Yes",
                                                  value: true,
                                                },
                                              }),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "No",
                                                  value: false,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              staticClass: "mb-4",
                                              attrs: {
                                                rules: [
                                                  (v) =>
                                                    v != null ||
                                                    "Select an answer",
                                                ],
                                                dense: "",
                                                hint: "MANDATORY FIELD - Can this attribute contain NULL data.",
                                                "persistent-hint": "",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(" Is Nullable? "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "red--text",
                                                        },
                                                        [_vm._v("*")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ]),
                                              model: {
                                                value: _vm.editedItem.nullable,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "nullable",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.nullable",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Yes",
                                                  value: true,
                                                },
                                              }),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "No",
                                                  value: false,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              staticClass: "mb-4",
                                              attrs: {
                                                rules: [
                                                  (v) =>
                                                    v != null ||
                                                    "Select an answer",
                                                ],
                                                dense: "",
                                                hint: "MANDATORY FIELD - The Default is NO. Selecting YES will make the attribute part of an alternate key that defines a unique row. An alternative to the Primary Key.",
                                                "persistent-hint": "",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        " Is Alternate Key? "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "red--text",
                                                        },
                                                        [_vm._v("*")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ]),
                                              model: {
                                                value:
                                                  _vm.editedItem.alternateKey,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "alternateKey",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.alternateKey",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Yes",
                                                  value: true,
                                                },
                                              }),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "No",
                                                  value: false,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "Default Value",
                                              maxlength: 250,
                                              outlined: "",
                                              counter: "",
                                              dense: "",
                                              hint: "When specifying value for Date field, please use the format as YYYY-MM-DD.",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem.defaultValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "defaultValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.defaultValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "Calculation",
                                              counter: "",
                                              outlined: "",
                                              "auto-grow": "",
                                              clearable: "",
                                              dense: "",
                                              required: "",
                                              hint: "Add Default Calculation to Attribute",
                                              "persistent-hint": "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _vm._v(" Calculation "),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value: _vm.editedItem.calculation,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "calculation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.calculation",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "Calculation Summary",
                                              counter: "",
                                              outlined: "",
                                              "auto-grow": "",
                                              clearable: "",
                                              dense: "",
                                              required: "",
                                              hint: "Add Calculation Summary to Attribute",
                                              "persistent-hint": "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _vm._v(
                                                      " Calculation Summary "
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value:
                                                _vm.editedItem
                                                  .calculationSummary,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "calculationSummary",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.calculationSummary",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "Hierarchy Level",
                                              maxlength: 20,
                                              outlined: "",
                                              counter: "",
                                              dense: "",
                                              hint: "If hierarchy Specify level here. Look at SC data to get an idea of how it has worked previously",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem.hierarchyLevel,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "hierarchyLevel",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.hierarchyLevel",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-autocomplete", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "Sort Order",
                                              items: _vm.sortOrders,
                                              placeholder:
                                                "Select a Sort Order",
                                              outlined: "",
                                              dense: "",
                                              clearable: "",
                                              hint: "Put 9999 as default",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value: _vm.editedItem.sortOrder,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "sortOrder",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.sortOrder",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-autocomplete", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "PDS Attribute Type",
                                              items:
                                                _vm.lookupData
                                                  .pdsAttributeTypes,
                                              "item-text": "text",
                                              "item-value": "id",
                                              placeholder:
                                                "Select a PDS Attribute Type",
                                              outlined: "",
                                              dense: "",
                                              clearable: "",
                                              hint: "This field is to be updated only for the objects with platform PDS Role-Play / PDS Cube and applicable only for FACT objects and not Dimensions.",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem
                                                  .pdsAttributeTypeId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "pdsAttributeTypeId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.pdsAttributeTypeId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "SME Notes TOA",
                                              maxlength: 10000,
                                              counter: "",
                                              outlined: "",
                                              "auto-grow": "",
                                              clearable: "",
                                              dense: "",
                                              hint: "Notes for the SME of that attribute (Dataowner)",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value: _vm.editedItem.smenotesToa,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "smenotesToa",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.smenotesToa",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-autocomplete", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "Cube Measure Group",
                                              "item-text": "text",
                                              "item-value": "id",
                                              items:
                                                _vm.lookupData.measureGroups,
                                              placeholder: "Select a KPI Area",
                                              outlined: "",
                                              dense: "",
                                              clearable: "",
                                              hint: "Used for Grouping Attributes into SSAS Measure groups in a Star Schema",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem.measureGroupId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "measureGroupId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.measureGroupId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "TOB File Partition",
                                              maxlength: 10000,
                                              counter: "",
                                              outlined: "",
                                              "auto-grow": "",
                                              clearable: "",
                                              dense: "",
                                              hint: "Used to indicate the attribute used for Market Segregation. Currently only used by Supply Chain.",
                                              "persistent-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem.tobfilePartition,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "tobfilePartition",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.tobfilePartition",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-autocomplete", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "Glossary Term",
                                              items:
                                                _vm.lookupData.glossaryTerms,
                                              "item-text": "text",
                                              "item-value": "id",
                                              placeholder:
                                                "Select Glossary Term",
                                              outlined: "",
                                              dense: "",
                                              clearable: "",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _vm._v(" Glossary Term "),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value:
                                                _vm.editedItem.glossaryTermId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "glossaryTermId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.glossaryTermId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              staticClass: "mb-4",
                                              attrs: { dense: "" },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        " Data Quality NULL Check? "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.editedItem.nullCheck =
                                                                null
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("mdi-close")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ]),
                                              model: {
                                                value: _vm.editedItem.nullCheck,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "nullCheck",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.nullCheck",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Yes",
                                                  value: true,
                                                },
                                              }),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "No",
                                                  value: false,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              staticClass: "mb-4",
                                              attrs: { dense: "" },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        " Data Quality Duplicate Check? "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.editedItem.duplicateCheck =
                                                                null
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("mdi-close")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ]),
                                              model: {
                                                value:
                                                  _vm.editedItem.duplicateCheck,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "duplicateCheck",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.duplicateCheck",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Yes",
                                                  value: true,
                                                },
                                              }),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "No",
                                                  value: false,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              staticClass: "mb-4",
                                              attrs: { dense: "" },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        " Data Quality Data Type Check? "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.editedItem.dataTypeCheck =
                                                                null
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("mdi-close")]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ]),
                                              model: {
                                                value:
                                                  _vm.editedItem.dataTypeCheck,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.editedItem,
                                                    "dataTypeCheck",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "editedItem.dataTypeCheck",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Yes",
                                                  value: true,
                                                },
                                              }),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "No",
                                                  value: false,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { "no-gutters": "" } },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              label: "Data Quality Data Format",
                                              maxlength: 100,
                                              outlined: "",
                                              counter: "",
                                              dense: "",
                                            },
                                            model: {
                                              value: _vm.editedItem.dataFormat,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "dataFormat",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.dataFormat",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-container",
                            [
                              !_vm.editItemIsValid
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              attrs: {
                                                color: "pink darken-1",
                                                outlined: "",
                                                dense: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "All data provided must be valid. Any fields marked with "
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "red--text" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(
                                                " are required. 'Save' button has been disabled until completed."
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.isBatchLocked
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              attrs: {
                                                color: "pink darken-1",
                                                outlined: "",
                                                dense: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " There is a scheduled job in progress that must be completed. Please wait and try refreshing later. Saving is currently disabled."
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !_vm.editedItem.isEditable
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              attrs: {
                                                color: "pink darken-1",
                                                outlined: "",
                                                dense: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "You must be the data owner or data set owner to 'Save' this item"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "text-uppercase",
                                          attrs: {
                                            block: "",
                                            tile: "",
                                            outlined: "",
                                            color: "secondary",
                                          },
                                          on: { click: _vm.closeEditDialog },
                                        },
                                        [_vm._v("Cancel")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "text-uppercase",
                                          attrs: {
                                            block: "",
                                            tile: "",
                                            disabled:
                                              !_vm.editItemIsValid ||
                                              _vm.isBatchLocked ||
                                              !_vm.editedItem.isEditable,
                                            color: "secondary",
                                          },
                                          on: { click: _vm.save },
                                        },
                                        [_vm._v("Save")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-spacer"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }